import { Drawer } from 'primeng/drawer';

// PrimeNG 22: Wird ein p-drawer nach close() zerstoert (z. B. per @if), entfernt onDestroy die Maske nicht
// (prueft visible() statt mask) -> unsichtbare Maske blockiert alle Klicks. Entfernen, sobald PrimeNG das behebt.
const originalOnDestroy = Drawer.prototype.onDestroy;
Drawer.prototype.onDestroy = function (this: Drawer): void {
    if (this.mask) this.destroyModal();
    originalOnDestroy.call(this);
};
